
import React from 'react';
import ComingSoonOverlay from '../ui/coming-soon-overlay';
import waitlistService from '../../services/waitlistService';

interface DashboardComingSoonProps {
  feature: 'social_analytics';
  title: string;
  description: string;
  features?: string[];
  expectedDate?: string;
  icon?: 'rocket' | 'zap' | 'bot';
}

const DashboardComingSoon: React.FC<DashboardComingSoonProps> = ({
  feature,
  title,
  description,
  features = [],
  expectedDate,
  icon = 'rocket'
}) => {

  const handleWaitlistJoin = async (email: string) => {
    try {
      await waitlistService.joinSocialFeaturesWaitlist(email, [feature]);
      console.log('Successfully joined the waitlist!');
    } catch (error) {
      console.error('Failed to join waitlist:', error);
      throw error;
    }
  };

  return (
    <ComingSoonOverlay
      title={title}
      description={description}
      features={features}
      expectedDate={expectedDate}
      onWaitlistJoin={handleWaitlistJoin}
      icon={icon}
      className="dashboard-analytics"
    />
  );
};

export default DashboardComingSoon;
